<div [formGroup]="form" class="password-fields">
  <div class="password-field">
    @if (showFieldLabels) {
      <span class="field-label">{{ 'dataManagement.userData.columns.password' | transloco }} *</span>
    }
    <mat-form-field appearance="outline" subscriptSizing="dynamic" class="input-field">
      @if (!showFieldLabels) {
        <mat-label>{{ 'dataManagement.userData.columns.password' | transloco }}</mat-label>
      }
      <input matInput formControlName="password" [type]="showNewPassword ? 'text' : 'password'"
        onDrag="return false" autocomplete="new-password" [attr.aria-label]="'dataManagement.userData.columns.password' | transloco">
      <button mat-icon-button matSuffix (click)="changeNewPasswordVisibility()" tabindex="-1" type="button">
        <mat-icon>{{ showNewPassword ? 'visibility' : 'visibility_off'}}</mat-icon>
      </button>
      @if (formControls.password.hasError('required')) {
        <mat-error>{{ 'dataManagement.userData.userDialog.validation.required' | transloco }}</mat-error>
      } @else if (formControls.password.hasError('minlength')) {
        <mat-error>{{ 'dataManagement.userData.userDialog.validation.minLength' | transloco: { minLength: minPasswordLength } }}</mat-error>
      } @else if (formControls.password.hasError('hasNumber')) {
        <mat-error>{{ 'dataManagement.userData.userDialog.validation.hasNumber' | transloco }}</mat-error>
      } @else if (formControls.password.hasError('hasCapitalCase')) {
        <mat-error>{{ 'dataManagement.userData.userDialog.validation.hasCapitalCase' | transloco }}</mat-error>
      } @else if (formControls.password.hasError('hasSmallCase')) {
        <mat-error>{{ 'dataManagement.userData.userDialog.validation.hasSmallCase' | transloco }}</mat-error>
      } @else if (formControls.password.hasError('hasSpecialCharacters')) {
        <mat-error>{{ 'dataManagement.userData.userDialog.validation.hasSpecialCharacters' | transloco }}</mat-error>
      }
    </mat-form-field>
  </div>

  <div class="password-field">
    @if (showFieldLabels) {
      <span class="field-label">{{ 'dataManagement.userData.columns.confirmedPassword' | transloco }} *</span>
    }
    <mat-form-field appearance="outline" subscriptSizing="dynamic" class="input-field">
      @if (!showFieldLabels) {
        <mat-label>{{ 'dataManagement.userData.columns.confirmedPassword' | transloco }}</mat-label>
      }
      <input matInput formControlName="confirmPassword" [type]="showConfirmPassword ? 'text' : 'password'"
        onDrop="return false" autocomplete="new-password" [attr.aria-label]="'dataManagement.userData.columns.confirmedPassword' | transloco">
      <button mat-icon-button matSuffix (click)="changeConfirmPasswordVisibility()" tabindex="-1" type="button">
        <mat-icon>{{ showConfirmPassword ? 'visibility' : 'visibility_off'}}</mat-icon>
      </button>
      @if (formControls.confirmPassword.hasError('required')) {
        <mat-error>{{ 'dataManagement.userData.userDialog.validation.required' | transloco }}</mat-error>
      } @else if (formControls.confirmPassword.hasError('mustMatch')) {
        <mat-error>{{ 'dataManagement.userData.userDialog.validation.notSame' | transloco }}</mat-error>
      }
    </mat-form-field>
  </div>
</div>
